module.exports = __webpack_public_path__ + "static/media/024.8488cbc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/024.jpg
// module id = 371
// module chunks = 0